const defaultState = {
  remainingSeconds: 0, // Remaining timer value
  error: null // Error message, if any
}

export default (state = defaultState, { type, data }) => {
  switch (type) {
    case 'GET_SENT_EMAIL_STATUS_SUCCESS':
      return {
        ...state,
        ...{
          remainingSeconds: data.remainingSeconds,
          error: null
        }
      }
    case 'GET_SENT_EMAIL_STATUS_FAILURE':
      return {
        ...state,
        ...data
      }
    case 'SEND_EMAIL_LIMIT_REACHED':
      return {
        ...state,
        ...data
      }
    default:
      return state
  }
}